import { createContext, useContext } from 'react';
import { generateId } from '@agilepoint/utils-common';
import { IPopupEventManager, PopupConfig, PopupEvent } from './popup-props';
import { getEventManager } from '../../utils';

export function createPopupEventManager(): IPopupEventManager {
    const popupEventManager = getEventManager<PopupEvent>();

    return {
        showPopup: (config: PopupConfig) => {
            const id = config.id || generateId();
            popupEventManager.emit('showPopup', { ...config, id });
        },
        removePopup: (id: string) => {
            popupEventManager.emit('removePopup', id);
        },
        subscribe: popupEventManager.on,
        unsubscribe: popupEventManager.off
    };
}

export const PopupEventManagerContext = createContext({} as IPopupEventManager);

export const usePopupEvents = () => useContext(PopupEventManagerContext);
